import * as React from 'react';
import { SVGProps } from 'react';

const SvgDiagnosisOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <g clipPath="url(#a)" fill="currentColor">
      <path d="M16 4a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h8Zm0 2H8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z" />
      <path d="M15 8h-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2ZM10 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM15 11h-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2ZM10 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM15 14h-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2ZM10 15a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgDiagnosisOutlined;
